<template>
  <div class="lb-portal">
    <footer>
      <nav class="container">
        <footer-top-row
          :contact-information-model="viewModel.ContactInformation"
          :links-model="viewModel.Columns"
        />
        <footer-bottom-row
          :logo-section="viewModel.LogoSection"
          :service-navigation="viewModel.ServiceNavigation"
        />
      </nav>
    </footer>
  </div>
</template>

<script>
import FooterBottomRow from './FooterBottomRow.vue';
import FooterTopRow from './FooterTopRow.vue';
import { Form } from 'vee-validate';

export default {
  name: 'SharedFooter',
  components: {
    FooterTopRow,
    FooterBottomRow,
    Form
  },
  data() {
    return {
      files: [],
      footerBoolean: false
    };
  },
  props: {
    viewModel: {
      type: Object,
      default() {
        return {
          ContactInformation: {},
          Columns: [],
          LogoSection: {},
          ServiceNavigation: {}
        };
      }
    }
  }
};
</script>
